import { CheckboxGroup } from '@mantine/core'
import { sendOutput, sendSignal } from '@shared/port-send-v1.0.0'
import { forwardRef, useEffect, useState } from 'react'
import type { Props } from '../node/definition'

export default forwardRef((p: Props) => {
	const [initialSetted, setInitialSetted] = useState(false)
	const [values, setValues] = useState<string[]>([])

	useEffect(() => {
		sendOutput(p.noodlNode, 'selectedValues', values)
		sendOutput(p.noodlNode, 'selectedItems', p.items?.find((i) => values.includes(R.libs.just.get(i, p.valuePath))) || [])
		sendSignal(p.noodlNode, 'changed')
	}, [values])

	useEffect(() => {
		if (!initialSetted) {
			setValues(p.initialSelected || [])
			setInitialSetted(true)
		}
	}, [p.initialSelected])

	return (
		<CheckboxGroup onChange={setValues} {...p} {...p.customProps} defaultValue={p.initialSelected || []}>
			{p.children}
		</CheckboxGroup>
	)
})
